import { Navigate, Routes, Route } from 'react-router-dom';
import { LandingPage } from '@/pages/LandingPage';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { EarningsCalendarPage } from '@/pages/EarningsCalendarPage';
import { EarningsDetailPage } from '@/pages/EarningsDetailPage';
import { StockAnalysisPage } from '@/pages/StockAnalysisPage';
import { StockAnalogueAnalysisPage } from '@/pages/StockAnalogueAnalysisPage';
import { StockComparisonPage } from '@/pages/StockComparisonPage';
import { MarketPredictionPage } from '@/pages/MarketPredictionPage';
import { MarketAnalysisPage } from '@/pages/MarketAnalysisPage';
import { SectorAnalysisPage } from '@/pages/SectorAnalysisPage';
import { CrossDayAnalogueAnalysisPage } from '@/pages/CrossDayAnalogueAnalysisPage';
import { MajorStoriesPage } from '@/pages/MajorStoriesPage';
import { StorylinesPage } from '@/pages/StorylinesPage';
import { TradesPage } from '@/pages/TradesPage';
import { MerlinPage } from '@/pages/MerlinPage';
import { ValueChainPage } from '@/pages/ValueChainPage';
import { QxoDeskPage } from '@/pages/QxoDeskPage';
import { MarketResearchArticlePage } from '@/pages/MarketResearchArticlePage';
import { RequestAccessPage } from '@/pages/RequestAccessPage';
import {
  DASHBOARD_MERLIN_ENABLED,
  DASHBOARD_QXO_ENABLED,
  DASHBOARD_VALUE_CHAIN_ENABLED,
} from '@/config/features';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/request-access" element={<RequestAccessPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      {DASHBOARD_MERLIN_ENABLED ? (
        <Route path="/merlin" element={<MerlinPage />} />
      ) : null}
      {DASHBOARD_VALUE_CHAIN_ENABLED ? (
        <Route path="/dashboard/value-chain" element={<ValueChainPage />} />
      ) : null}
      {DASHBOARD_QXO_ENABLED ? <Route path="/dashboard/qxo" element={<QxoDeskPage />} /> : null}
      <Route path="/market/prediction" element={<MarketPredictionPage />} />
      <Route path="/market/prediction/:referenceDate" element={<MarketPredictionPage />} />
      <Route path="/market/analysis" element={<MarketAnalysisPage />} />
      <Route path="/market/sector-analysis" element={<SectorAnalysisPage />} />
      <Route path="/market/major-stories/:rank" element={<MajorStoriesPage />} />
      <Route path="/market/major-stories" element={<MajorStoriesPage />} />
      <Route path="/market/storylines/:id" element={<StorylinesPage />} />
      <Route path="/market/storylines" element={<StorylinesPage />} />
      <Route path="/market/trades/:referenceDate/:strategyId" element={<TradesPage />} />
      <Route path="/market/trades" element={<TradesPage />} />
      <Route
        path="/market/research/:date/:articleId"
        element={<MarketResearchArticlePage />}
      />
      <Route
        path="/market/ai-receipt-stack"
        element={
          <Navigate
            to="/market/research/2026-07-30/ai-receipt-overlooked-stack"
            replace
          />
        }
      />
      <Route
        path="/market/unpaid-layer-thermal-trio"
        element={
          <Navigate
            to="/market/research/2026-08-07/unpaid-layer-liquid-cooling-thermal-trio"
            replace
          />
        }
      />
      <Route
        path="/market/nuclear-fuel-cycle-firm-power"
        element={
          <Navigate
            to="/market/research/2026-08-07/Nuclear-Fuel-Cycle-Firm-Power"
            replace
          />
        }
      />
      <Route path="/market/cross-day-analogue" element={<CrossDayAnalogueAnalysisPage />} />
      <Route path="/earnings" element={<EarningsCalendarPage />} />
      <Route path="/earnings/:id" element={<EarningsDetailPage />} />
      <Route path="/stock/:ticker/analogue-analysis" element={<StockAnalogueAnalysisPage />} />
      <Route path="/stock/:ticker" element={<StockAnalysisPage />} />
      <Route path="/compare" element={<StockComparisonPage />} />
    </Routes>
  );
}

